import { render, staticRenderFns } from "./LiveFeed.vue?vue&type=template&id=51760b8a"
import script from "./LiveFeed.vue?vue&type=script&lang=js"
export * from "./LiveFeed.vue?vue&type=script&lang=js"
import style0 from "./LiveFeed.vue?vue&type=style&index=0&id=51760b8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports